// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bf9140ae","377":"bc7cc4de","644":"0b99b16b","791":"1a996afd"}[chunkId] + ".chunk.js";
};